<div class="run-dialog">
  <header class="run-dialog__header">
    <h2 mat-dialog-title class="run-dialog__title">{{ 'testCases.run.title' | translate }}</h2>
    <p class="run-dialog__subtitle">
      @if (data.testCaseKey) {
        <code>{{ data.testCaseKey }}</code>
      }
      {{ data.testCaseTitle }}
    </p>
  </header>

  <mat-dialog-content class="run-dialog__content">
    <div class="run-dialog__options" role="radiogroup" [attr.aria-label]="'testCases.run.title' | translate">
      <button
        #runOption
        type="button"
        role="radio"
        class="run-option"
        [class.run-option--selected]="selected() === 'MANUAL'"
        [attr.aria-checked]="selected() === 'MANUAL'"
        [attr.tabindex]="selected() === 'MANUAL' ? 0 : -1"
        data-testid="run-mode-manual"
        (keydown)="onOptionKeydown($event)"
        (click)="select('MANUAL')"
      >
        <mat-icon class="run-option__icon" aria-hidden="true">touch_app</mat-icon>
        <span class="run-option__body">
          <span class="run-option__label">{{ 'testCases.run.manual.label' | translate }}</span>
          <span class="run-option__hint">{{ 'testCases.run.manual.hint' | translate }}</span>
        </span>
      </button>

      <button
        #runOption
        type="button"
        role="radio"
        class="run-option"
        [class.run-option--selected]="selected() === 'LOCAL_AUTOMATED'"
        [class.run-option--disabled]="!localAvailable()"
        [attr.aria-checked]="selected() === 'LOCAL_AUTOMATED'"
        [attr.tabindex]="selected() === 'LOCAL_AUTOMATED' ? 0 : -1"
        [disabled]="!localAvailable()"
        data-testid="run-mode-local"
        (keydown)="onOptionKeydown($event)"
        (click)="select('LOCAL_AUTOMATED')"
      >
        <mat-icon class="run-option__icon" aria-hidden="true">play_circle</mat-icon>
        <span class="run-option__body">
          <span class="run-option__label">{{ 'testCases.run.local.label' | translate }}</span>
          <span class="run-option__hint">
            @if (stepCountFailed()) {
              {{ 'testCases.run.local.stepsCheckFailed' | translate }}
            } @else if (stepCount() === null) {
              {{ 'testCases.run.local.checkingSteps' | translate }}
            } @else if (localAvailable()) {
              {{ 'testCases.run.local.hint' | translate: { count: stepCount() } }}
            } @else {
              {{ 'testCases.run.local.noSteps' | translate }}
            }
          </span>
        </span>
      </button>
    </div>

    <app-runner-target-select
      class="run-dialog__runners"
      [visible]="selected() === 'LOCAL_AUTOMATED'"
      (targetChange)="target.set($event)"
      (connect)="cancel()"
    />
  </mat-dialog-content>

  <mat-dialog-actions class="run-dialog__actions">
    <button mat-stroked-button type="button" data-testid="run-cancel" (click)="cancel()">
      {{ 'common.cancel' | translate }}
    </button>
    <button
      mat-flat-button
      type="button"
      class="run-dialog__start"
      data-testid="run-start"
      [disabled]="startDisabled()"
      (click)="start()"
    >
      <mat-icon aria-hidden="true">play_arrow</mat-icon>
      {{ 'testCases.run.start' | translate }}
    </button>
  </mat-dialog-actions>
</div>
